import React, { useEffect,useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { useTypedSelector } from '../hooks/useTypedSelector';
import NoProjectsComponent from "./no_projects";
import ProjectsList from './projectsList'
import { makeProjectsActionType } from '../state/action';
import ActionTypes from '../constants';
import useActions from '../hooks/useActions';


interface ProjectsComponentProps {
    tabName: makeProjectsActionType;
}

export const ProjectsComponent: React.FC<ProjectsComponentProps> = ({tabName}) => {
    const [count, setCount] = useState(0);
    const [showNextSetLoader,setNextSetLoader] = useState(true);
    
    const scrollRef = useRef<Object>({})
    
    const projectsRes = useTypedSelector(state =>  state[tabName]);
    const projectsTotalCount = useTypedSelector(state =>  state.projectsCount[tabName])
    const { makeProjectsCall, resetGivenReduxKeyData} = useActions();
    
    const [ref, inView, entry] =  useInView({
        /* Optional options */
        threshold: 0.5,
    });

    const updateScrollPos = () => {
        // @ts-ignore
        var year = photoOrg.Util.getURLParameter('projectYear');
        if(year){
             const domPresent = scrollRef.current && scrollRef.current[year]
            if (domPresent){
                 scrollRef.current[year].scrollIntoView();
            }
        }  
    }

    const fetchMoreData = () => {
        if(count < projectsTotalCount){
            if(count < projectsRes.length){
                setCount(projectsRes.length + 1);
            }
        } else{
            //hide spinning wheel
            setNextSetLoader(false);
        }
    }

    useEffect(()=>{        
        if(inView) {
            fetchMoreData();
        }  
    },[inView])
    //hook which is invoked when there is a parameter to load a
    //specific month projects.
    useEffect(()=>{        
        if(tabName === ActionTypes.SAVED && projectsRes !== null 
             // @ts-ignore
            && photoOrg.Util.getURLParameter('projectYear') !== null){
            updateScrollPos();
        }  
    },[projectsRes])

    // useEffect(()=>{                
    //     currentTabName(tabName);             
    // },[tabName])

    useEffect(()=>{
        return () => {
            //resetting the data upon component unload
            resetGivenReduxKeyData(tabName);
        }
    },[])

    useEffect(()=>{        
       setTimeout(()=>{
        makeProjectsCall(tabName,count);
       },0);
    },[count])

    if(!projectsRes){        
        return (<div id="loadingBar" className="project-tiles-loading"><span className="icon-po-spin5 animate-spin"></span><div className="loading-dots mediumdots"><span role="status" className="dotid"></span></div></div>)
    }else if(count > projectsTotalCount && showNextSetLoader){
        //hide spinning wheel        
        setNextSetLoader(false);
    }

    let noProjectsHeading = "";
    let noProjectsBody = "";

    try{// @ts-ignore
        noProjectsHeading= photoOrg.translations.projects["projects"][tabName]["no_projects_body"];
        // @ts-ignore
        noProjectsBody = photoOrg.translations.projects["projects"][tabName]["no_projects_body_sub"];
    }catch(e){}
    
    // @ts-ignore
    if(photoOrg.Util){
        //capturing the load paint metrics   
        // @ts-ignore     
        photoOrg.Util.captureOnLoadPaintMetrics();
        //omniture tracking
        // @ts-ignore
        photoOrg.Util.delayTrackOmnitureForPage({ 'pageName' : "Projects"});
    }

    return (
        (projectsRes.length == 0)? 
        <NoProjectsComponent 
        state={tabName}
        heading={noProjectsHeading}
        bodyText={noProjectsBody}>
        </NoProjectsComponent> : 
        <React.Fragment>
        <ProjectsList ref={scrollRef} data={projectsRes} projectState={tabName}></ProjectsList>        
        {showNextSetLoader ? <div id="loadingBar" className="project-tiles-loading" ref={ref}><span className="icon-po-spin5 animate-spin"></span><div className="loading-dots mediumdots"><span role="status" className="dotid"></span></div></div> : null}
        </React.Fragment>
    )
    
}


ProjectsComponent.defaultProps = {
    tabName: ActionTypes.SAVED
}
export default ProjectsComponent;


// const mapStateToProps = (state,props) => {
//     return {
//         projectsRes : state[tabName],
//         projectsTotalCount: state.projectsCount[tabName]      
//     }
// }

// export default connect(mapStateToProps,{
//     makeProjectsCall,
//     resetGivenReduxKeyData,
//     currentTabName    
// })(ProjectsComponent);